import { CoreService } from "src/app/shared/services/core.service";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { API } from "./paymentapiroutes";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  constructor(private apiService: ApiService) {}

  getCategories(param: string): Observable<any> {
    var reqURl = `${CoreService.retailerId}/product-category`;
    if (param.includes("?")) {
      reqURl += param;
    }

    return this.apiService.get(API.CATEGORY + reqURl);
  }
}
